import React, { useState } from 'react';
import { Menu, MenuItem, Sidebar, SubMenu } from 'react-pro-sidebar';
import { useLocation } from 'react-router-dom';
import Header from '../../../components/Header/Header';
import { Box } from '@mui/material';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import ManageUsers from './UserManagment/ManageUsers/ManageUsers';
import RailCalendar from './RailCalendar/RailCalendar';
import CreateWorker from './UserManagment/CreateNewWorker/CreateWorker';
import { faBars, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdminDashboard from './Dashboard/Dashboard';
import styles from "./Dashboard.module.css"
import FRIButton from './UserManagment/FRI/FRIButton';
import PasswordRecovery from './UserManagment/PasswordRecovery/PasswordRecovery';
import Duplicates from './UserManagment/Duplicates/Duplicates';
import IdentificationType from '../../RT-Data/IdentificationType/IdentificationType';
import SendEmails from '../../UpdateDataPage/SendEmails/SendEmails';
import DeleteRequests from './DeleteRequests';
import Roles from './Roles/Roles';
import PayRateTypes from './PayRateTypes/PayRateTypes';

const Dashboard = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [menuClicked, setMenuClicked] = useState('Dashboard');

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const menuItemStyle = {
    color: '#333',
    fontWeight: 500,
  };

  return (
    <>
      {!location.pathname.includes('/resourcing') && <Header />}
      <div className={styles.layout}>
        <Sidebar collapsed={collapsed} backgroundColor='white' style={{height: '100%'}}>
          <Menu>
            <MenuItem
              style={menuItemStyle}
              onClick={toggleSidebar}
              icon={<FontAwesomeIcon icon={faBars} size='lg' />}
            />
            <MenuItem
              style={menuItemStyle}
              onClick={() => setMenuClicked('Dashboard')}
              icon={<GridViewRoundedIcon sx={{fontSize: 25}} />}
            >
              Dashboard
            </MenuItem>
            <MenuItem
              style={menuItemStyle}
              onClick={() => setMenuClicked('RailCalendar')}
              icon={<FontAwesomeIcon icon={faCalendarDays} style={{fontSize: 22}} />}
            >
              Rail Calendar
            </MenuItem>
            <SubMenu
              label="User Management"
              style={menuItemStyle}
              icon={<ManageAccountsRoundedIcon sx={{fontSize: 25}} />}
            >
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('ManageUsers')}
              >
                Manage Users
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('CreateWorker')}
              >
                Create New User
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('FRI')}
              >
                FRI Admin Panel
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('Roles')}
              >
                Roles
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('Duplicates')}
              >
                Duplicates
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('IdenType')}
              >
                Identification Type
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('passwordRecovery')}
              >
                Password Recovery
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('deleteRequests')}
              >
                Delete Requests
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('sendEmails') }
              >
                Send Emails
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('payRate') }
              >
                Rate Types
              </MenuItem>
            </SubMenu>
          </Menu>
        </Sidebar>
        {menuClicked === 'Dashboard' &&
          <AdminDashboard />  
        }
        {menuClicked === 'ManageUsers' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <ManageUsers />
          </Box>
        }
        {menuClicked === 'RailCalendar' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <RailCalendar />
          </Box>
        }
        {menuClicked === 'CreateWorker' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <CreateWorker menuClicked={menuClicked} setMenuClicked={setMenuClicked} />
          </Box>
        }
        {menuClicked === 'FRI' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <FRIButton />
          </Box>
        }
        {menuClicked === 'Duplicates' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <Duplicates />
          </Box>
        }
        {menuClicked === 'Roles' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <Roles />
          </Box>
        }
        {menuClicked === 'passwordRecovery' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <PasswordRecovery />
          </Box>
        }
        {menuClicked === 'IdenType' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <IdentificationType />
          </Box>
        }
        {menuClicked === 'deleteRequests' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <DeleteRequests />
          </Box>
        }
        {menuClicked === 'sendEmails' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <SendEmails />
          </Box>
        }
        {menuClicked === 'payRate' &&
          <Box
            sx={{
              width: "100%",
              bgcolor: 'white'
            }}>
            <PayRateTypes />
          </Box>
        }
      </div>
    </>
  );
};

export default Dashboard;
